import React, { FC } from 'react';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';

import { isSuccess } from 'utils/responseStatus';

import { useCreateNomenclatureTransferMutation } from 'bus/nomenclatureTransfer/services';
import { NomenclatureTransfer } from 'bus/nomenclatureTransfer/types';

import { NomenclatureTransferForm } from '../components/NomenclatureTransferForm';

export const NomenclatureTransferCreateScreen: FC = () => {
  const history = useHistory();
  const [createNomenclatureTransfer, { isLoading }] = useCreateNomenclatureTransferMutation();

  const handleSubmit = (form: NomenclatureTransfer) => {
    createNomenclatureTransfer(form).then((data) => {
      if (isSuccess(data)) {
        toast.success('Запись успешно добавлена', {
          position: 'bottom-right',
        });
        history.push('/nomenclatureTransferList');
      }
    });
  };

  return (
    <div>
      <NomenclatureTransferForm onSubmit={handleSubmit} loading={isLoading} />
    </div>
  );
};
